var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"box noselect"},[_c('b-field',{attrs:{"label":"Muscle Selection"}},[_c('b-switch',{attrs:{"value":_vm.value},on:{"input":_vm.handleInput}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }